module.exports = __webpack_public_path__ + "img/lv.ac11fe25.jpg";